import axios from "axios";
import { databaseUrl } from "./server";
import { databaseNoport } from "./server";

let access = localStorage.getItem("accesstoken");

const axiosInstance = axios.create({
  baseURL: databaseUrl,
  headers: {Authorization:`Bearer ${access}`}
})

axios.interceptors.request.use( 
  config => {return config;},
  error => {return Promise.reject(error);}
)

axiosInstance.interceptors.response.use(
  response => {return response;},
  error => {
    if(error.response?.status === 401){
      const refresh = localStorage.getItem("refreshtoken");
      axios.post(`${databaseUrl}/users/refresh`,{},{
        headers: {Authorization:`Bearer ${refresh}`},
      }).then((response)=>{
//        console.log('response part')

        localStorage.setItem("accesstoken",response.data.accesstoken);
        localStorage.setItem("refreshtoken",response.data.refreshtoken);
        window.location.reload();
      }).catch((error) => {
//        console.log('error part')
        localStorage.removeItem("happycallname");
        localStorage.removeItem("happycallgrade");
        alert(`Not Login PLZ LOGIN`);
        //window.location.href = `${databaseNoport}/SignIn`;
        //window.location.reload();
      })
    }
  }
);

export default axiosInstance;